var map = {
	"./subnav.de-CH.json": 1397,
	"./subnav.de-DE.json": 1398,
	"./subnav.en-CA.json": 1399,
	"./subnav.en-GB.json": 1400,
	"./subnav.en-IN.json": 1401,
	"./subnav.en-ME.json": 1402,
	"./subnav.en-US.json": 1403,
	"./subnav.es-EM.json": 1404,
	"./subnav.es-ES.json": 1405,
	"./subnav.fr-BE.json": 1406,
	"./subnav.fr-CA.json": 1407,
	"./subnav.fr-CH.json": 1408,
	"./subnav.nl-BE.json": 1409,
	"./subnav.nl-NL.json": 1410,
	"./subnav.pl-PL.json": 1411,
	"./subnav.pt-BR.json": 1412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1396;